import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { CONTENT_DATA } from './data';
import { ContentItem } from './contentItem';

const CustomAccordion = styled(Accordion)(({ theme }) => ({
  backgroundColor: 'transparent',
  color: '#ffffff',
  '&:before': {
    display: 'none'
  },
  '&.Mui-expanded': {
    margin: 0
  },
  borderBottom: '1px solid rgba(42, 19, 106, 1)'
}));

const CustomAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  padding: '0 16px',
  minHeight: 60,
  position: 'relative',
  '&.Mui-expanded': {
    minHeight: 60,
    fontWeight: 600,
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 4,
      top: '50%',
      transform: 'translateY(-50%)',
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '6px 0 6px 8px',
      borderColor: 'transparent transparent transparent rgba(86, 54, 174, 1)'
    }
  },
  '& .MuiAccordionSummary-content': {
    margin: '12px 0',
    paddingLeft: '8px',
    '&.Mui-expanded': {
      margin: '12px 0'
    }
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: '#ffffff',
    '&::after': {
      content: '""',
      display: 'inline-block',
      width: '8px',
      height: '8px',
      borderRight: '2px solid #ffffff',
      borderBottom: '2px solid #ffffff',
      transform: 'rotate(45deg)',
      transition: 'transform 0.2s ease-in-out'
    },
    '&.Mui-expanded': {
      transform: 'rotate(180deg)'
    }
  },
  fontSize: '16px'
}));

const CustomAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: '0 16px 16px'
}));

export default function CookieMobileContent() {
  const [expanded, setExpanded] = React.useState<string | false>('panel0');

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <Box className="h-[calc(100vh_-_240px)] w-full overflow-y-auto">
      {CONTENT_DATA.map((item, index) => (
        <CustomAccordion
          key={item.title}
          expanded={expanded === `panel${index}`}
          onChange={handleChange(`panel${index}`)}
        >
          <CustomAccordionSummary
            aria-controls={`panel${index}-content`}
            id={`panel${index}-header`}
          >
            <Typography
              sx={{
                fontSize: '16px',
                fontWeight: expanded === `panel${index}` ? 600 : 400
              }}
            >
              {item.title}
            </Typography>
          </CustomAccordionSummary>
          <CustomAccordionDetails>
            <ContentItem item={item} />
          </CustomAccordionDetails>
        </CustomAccordion>
      ))}
    </Box>
  );
}
